import { store } from "../../store";

export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/regions/countries_with_licenses";
export const ADD_DEPT_URL = "/api/v1/licenses/create";
export const UPD_DEPT_URL = "/api/v1/licenses/update";
